import { render } from "./PentestSummary.vue?vue&type=template&id=197b3914&scoped=true"
import script from "./PentestSummary.vue?vue&type=script&lang=js"
export * from "./PentestSummary.vue?vue&type=script&lang=js"

import "./PentestSummary.vue?vue&type=style&index=0&id=197b3914&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197b3914"]])

export default __exports__